import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlaceTags = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['tags'] => getPlace(placeKey)(store).tags;
